import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withNetwork } from 'react-fns'
import ErrorWorker from 'worker-loader!../workers/error-logger.js'
import { localStorage as local } from '@entrata/utils'
import { ERRORS_STORAGE_KEY } from 'portal-modules/common/constants/keys'
import { connect } from 'react-redux'
import { updateOfflineStatus } from '../redux/modules/offline'

const LocalSyncer = props => {
  useEffect(() => {
    logStashedErrors()
  }, [])

  useEffect(() => {
    const { dispatch, online } = props
    dispatch(updateOfflineStatus(!online))
    if (online) logStashedErrors()
  }, [props.online])

  const logStashedErrors = () => {
    setTimeout(() => {
      const errors = local.get(ERRORS_STORAGE_KEY)

      if (errors) {
        const worker = new ErrorWorker()
        worker.addEventListener('message', e => {
          if (e.data.success) local.remove(ERRORS_STORAGE_KEY)
        })
        worker.postMessage(errors)
      }
    }, 0)
  }

  return null
}

LocalSyncer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  online: PropTypes.bool.isRequired,
  offlineAt: PropTypes.object,
}

const ConnectedLocalSyncer = connect()(LocalSyncer)

export default withNetwork(ConnectedLocalSyncer)
